import { render } from "./Lead.vue?vue&type=template&id=78efba62&scoped=true"
import script from "./Lead.vue?vue&type=script&lang=js"
export * from "./Lead.vue?vue&type=script&lang=js"

import "./Lead.vue?vue&type=style&index=0&id=78efba62&lang=css"
import "./Lead.vue?vue&type=style&index=1&id=78efba62&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78efba62"]])

export default __exports__